import classNames from 'classnames';
import { ModifiedFieldsContext } from 'components/secondaryMarket/shared';
import { TextArea } from 'components/secondaryMarket/shared/Textarea';
import { FC, useContext } from 'react';

interface CommentProps {
  comment?: string;
  onCommentChanged: (value: string) => void;
}

export const Comment: FC<CommentProps> = ({ comment, onCommentChanged }) => {
  const modifiedFields = useContext(ModifiedFieldsContext);
  const isModified = modifiedFields?.includes('comment');
  return (
    <div className={classNames('mx-1 mb-3', { ['border border-info']: isModified })}>
      <TextArea
        id="Comment"
        placeholder="secondaryMarket.saleMarginInformation.comment.placeholder"
        value={comment ?? ''}
        onValueChanged={onCommentChanged}
        rows={3}
      />
    </div>
  );
};

Comment.displayName = 'Comment';
